export function Debounce(delay = 300): MethodDecorator {
  return function (
    target: Object,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor
  ): PropertyDescriptor {
    const original = descriptor.value;
    const timeoutPropertyKey = Symbol(`__timeout_${String(propertyKey)}`);

    descriptor.value = function (...args: any[]) {
      // Clear any existing timeout
      clearTimeout(this[timeoutPropertyKey]);
      
      // Set a new timeout
      this[timeoutPropertyKey] = setTimeout(() => {
        original.apply(this, args);
      }, delay);
    };

    return descriptor;
  };
} 